export default {
    //获取路由名称
    getRouterName(states) {
        return states.routerName;
    }
}




// WEBPACK FOOTER //
// ./src/store/navigation/getters.js